import * as React from 'react'
function SvgWays(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18 4a2 2 0 012 2v26h2a2 2 0 110 4h-8a2 2 0 110-4h2V22H8l-4-4 4-4h8V6a2 2 0 012-2zm14 14l4 4-4 4h-8v-8h8zm0-12l4 4-4 4h-8V6h8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgWays
